var slice = [].slice;

module.exports = Groupon.DFPAds = {
  load: function() {
    var h;
    h = document.head;
    if (!(h.querySelector("meta[name='dfp-slot']") || h.querySelector("meta[name='dfp-target']"))) {
      return;
    }
    Groupon.Utils.loadAsyncJS('//www.googletagservices.com/tag/js/gpt.js');
    return googletag.cmd.push(function() {
      var data, getAttrs, i, len, meta, metatags, read;
      read = function(s) {
        s = s.replace(/&#39;/g, "\x27").replace(/&quot;/g, '\x22').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&');
        try {
          s = JSON.parse(s);
        } catch (error) {}
        return s;
      };
      getAttrs = function() {
        var data, i, len, meta, name, names, type;
        meta = arguments[0], type = arguments[1], names = 3 <= arguments.length ? slice.call(arguments, 2) : [];
        if (meta.name !== type) {
          return;
        }
        data = {};
        for (i = 0, len = names.length; i < len; i++) {
          name = names[i];
          try {
            data[name] = read(meta.getAttribute("data-" + name));
          } catch (error) {}
        }
        return data;
      };
      metatags = h.getElementsByTagName('meta');
      for (i = 0, len = metatags.length; i < len; i++) {
        meta = metatags[i];
        if ((data = getAttrs(meta, 'dfp-slot', 'target', 'size', 'div'))) {
          googletag.defineSlot(data.target, data.size, data.div).addService(googletag.pubads());
        } else if ((data = getAttrs(meta, 'dfp-target', 'key', 'val'))) {
          googletag.pubads().setTargeting(data.key, data.val);
        }
      }
      googletag.pubads().enableSingleRequest();
      return googletag.enableServices();
    });
  }
};

if (!document.head.querySelector("meta[name='dfp-manual']")) {
  Groupon.DFPAds.load();
}

//# sourceMappingURL=data:application/json;base64,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
